var slice = [].slice;

module.exports = Groupon.DFPAds = {
  load: function() {
    var h;
    h = document.head;
    if (!(h.querySelector("meta[name='dfp-slot']") || h.querySelector("meta[name='dfp-target']"))) {
      return;
    }
    Groupon.Utils.loadAsyncJS('//www.googletagservices.com/tag/js/gpt.js');
    return googletag.cmd.push(function() {
      var data, getAttrs, i, len, meta, metatags, read;
      read = function(s) {
        s = s.replace(/&#39;/g, "\x27").replace(/&quot;/g, '\x22').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        try {
          s = JSON.parse(s);
        } catch (error) {}
        return s;
      };
      getAttrs = function() {
        var data, i, len, meta, name, names, type;
        meta = arguments[0], type = arguments[1], names = 3 <= arguments.length ? slice.call(arguments, 2) : [];
        if (meta.name !== type) {
          return;
        }
        data = {};
        for (i = 0, len = names.length; i < len; i++) {
          name = names[i];
          try {
            data[name] = read(meta.getAttribute("data-" + name));
          } catch (error) {}
        }
        return data;
      };
      metatags = h.getElementsByTagName('meta');
      for (i = 0, len = metatags.length; i < len; i++) {
        meta = metatags[i];
        if ((data = getAttrs(meta, 'dfp-slot', 'target', 'size', 'div'))) {
          googletag.defineSlot(data.target, data.size, data.div).addService(googletag.pubads());
        } else if ((data = getAttrs(meta, 'dfp-target', 'key', 'val'))) {
          googletag.pubads().setTargeting(data.key, data.val);
        }
      }
      googletag.pubads().enableSingleRequest();
      return googletag.enableServices();
    });
  }
};

if (!document.head.querySelector("meta[name='dfp-manual']")) {
  Groupon.DFPAds.load();
}

//# sourceMappingURL=data:application/json;base64,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
